var slice = [].slice;

module.exports = Groupon.DFPAds = {
  load: function() {
    var h;
    h = document.head;
    if (!(h.querySelector("meta[name='dfp-slot']") || h.querySelector("meta[name='dfp-target']"))) {
      return;
    }
    Groupon.Utils.loadAsyncJS('//www.googletagservices.com/tag/js/gpt.js');
    return googletag.cmd.push(function() {
      var data, getAttrs, i, len, meta, metatags, read;
      read = function(s) {
        s = s.replace(/&#39;/g, "\x27").replace(/&quot;/g, '\x22').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        try {
          s = JSON.parse(s);
        } catch (error) {}
        return s;
      };
      getAttrs = function() {
        var data, i, len, meta, name, names, type;
        meta = arguments[0], type = arguments[1], names = 3 <= arguments.length ? slice.call(arguments, 2) : [];
        if (meta.name !== type) {
          return;
        }
        data = {};
        for (i = 0, len = names.length; i < len; i++) {
          name = names[i];
          try {
            data[name] = read(meta.getAttribute("data-" + name));
          } catch (error) {}
        }
        return data;
      };
      metatags = h.getElementsByTagName('meta');
      for (i = 0, len = metatags.length; i < len; i++) {
        meta = metatags[i];
        if ((data = getAttrs(meta, 'dfp-slot', 'target', 'size', 'div'))) {
          googletag.defineSlot(data.target, data.size, data.div).addService(googletag.pubads());
        } else if ((data = getAttrs(meta, 'dfp-target', 'key', 'val'))) {
          googletag.pubads().setTargeting(data.key, data.val);
        }
      }
      googletag.pubads().enableSingleRequest();
      return googletag.enableServices();
    });
  }
};

if (!document.head.querySelector("meta[name='dfp-manual']")) {
  Groupon.DFPAds.load();
}

//# sourceMappingURL=data:application/json;base64,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
